/*
 * This file is created by Vatsaly Patel
 * Note: If you are editing anything, please let me know - or do comment [it's compulsory]
 */

import React, { Component, createRef } from "react";
import Label from "../../components/label";
import ICDateInput from "../../components/form/dateInput";
import ICButton from "../../components/button";
import TaxInvoiceList from "../../containers/TaxInvoiceList";
import MonthlySummaryModel from "../../containers/Models/MonthlyPaymentSummary";
import MakeAPICall from "../../apiCalls/common";
import moment from "moment";
import { getPaymentSummariesListNew } from "../../apiRoutes";
import { CSVLink } from "react-csv";
import html2pdf from "html2pdf.js";
import FullLogo from "../../assets/images/group-3@3x.png";
import WebLogo from "../../assets/images/earth.png";
import EmailLogo from "../../assets/images/mail.png";
import PhoneLogo from "../../assets/images/phone.png";
import { connect } from "react-redux";
import AvenirNextBoldEOT from "../../assets/fonts/AvriNextFont/avenir-next-bold.eot";
import AvenirNextBoldTTF from "../../assets/fonts/AvriNextFont/avenir-next-bold.ttf";
import AvenirNextBoldWOFF from "../../assets/fonts/AvriNextFont/avenir-next-bold.woff";
import AvenirNextRegularEOT from "../../assets/fonts/AvriNextFont/avenir-next-regular.eot";
import AvenirNextRegularTTF from "../../assets/fonts/AvriNextFont/avenir-next-regular.ttf";
import AvenirNextRegularWOFF from "../../assets/fonts/AvriNextFont/avenir-next-regular.woff";
import AvenirNextThinEOT from "../../assets/fonts/AvriNextFont/avenir-next-thin.eot";
import AvenirNextThinTTF from "../../assets/fonts/AvriNextFont/avenir-next-thin.ttf";
import AvenirNextThinWOFF from "../../assets/fonts/AvriNextFont/avenir-next-thin.woff";
import AvenirNextMediumEOT from "../../assets/fonts/AvriNextFont/AvenirLTPro-Medium.eot";
import AvenirNextMediumTTF from "../../assets/fonts/AvriNextFont/AvenirLTPro-Medium.ttf";
import AvenirNextMediumWOFF from "../../assets/fonts/AvriNextFont/AvenirLTPro-Medium.woff";
import Loader from "../../components/loader";
import ICIconBtn from "../../components/iconButton";

class TaxInvoicesPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openMonthlySummaryModel: false,
      apiCall: null,
      apiLoading: false,
      startDate: moment()
        .subtract(7, "days")
        .toISOString(),
      endDate: new Date().toISOString(),
      dateFilterApply: null,
      totalYears: [],
      monthlySummaryCSV: null,
      headers: [
        { label: "Tax Invoice", key: "appointmentId" },
        { label: "Date", key: "createdAt" },
        { label: "PM Fee", key: "PMFeeAmount" },
        { label: "GST On PM Fee", key: "taxAmount" },
        { label: "Total Invoice", key: "totalInvoice" }
      ],
      data: [
        { firstname: "Ahmed", lastname: "Tomi", email: "ah@smthing.co.com" },
        { firstname: "Raed", lastname: "Labes", email: "rl@smthing.co.com" },
        { firstname: "Yezzi", lastname: "Min l3b", email: "ymin@cocococo.com" }
      ],
      doctorName:
        props.auth.userData.firstName + " " + props.auth.userData.lastName,
      abn: props.auth.userData.ABN,
      unitNumber:
        props.auth.userData.address && props.auth.userData.address.unitNumber
          ? props.auth.userData.address.unitNumber
          : "",
      streetNumber: props.auth.userData.address.streetNumber,
      streetName: props.auth.userData.address.streetName,
      suburb: props.auth.userData.address.suburb,
      state: props.auth.userData.address.state,
      postCode: props.auth.userData.address.postCode,
      doctorEmail: props.auth.userData.email,
      supportEmail: props.auth.appConstant.email,
      // supportPhone: props.auth.appConstant.phoneNumber
      supportPhone: props.auth.appConstant.phoneNumber
        ? props.auth.appConstant.phoneNumber.slice(0, 4) +
          " " +
          props.auth.appConstant.phoneNumber.slice(4, 7) +
          " " +
          props.auth.appConstant.phoneNumber.slice(7)
        : "-",
      filterActive: true
    };
    this.csvInput = createRef();
  }

  downloadMonthlySummary = formValue => {
    this.setState({
      apiLoading: true
    });
    // let startDate = moment([formValue.year, formValue.month - "1"]),
    //   endDate = moment(startDate).endOf("month");
    // let paramData = {
    //   startDate: moment(startDate)
    //     .add(1, "d")
    //     .toISOString(),
    //   endDate: endDate.toISOString()
    // };

    let startDate = moment([formValue.year, formValue.month - "1"]),
      endDate = moment(startDate).endOf("month");
    let paramData = {
      startDate: moment(startDate)
        .add(0, "d")
        .toISOString(),
      endDate: endDate.toISOString()
    };

    let apiCallParam = {
      reqType: "GET",
      reqURL: getPaymentSummariesListNew,
      dataObj: {},
      params: paramData,
      headers: {},
      successCallback: res => {
        let totalPMFee = 0,
          totalTax = 0,
          totalInvoices = 0,
          rows = "",
          monthlySummaryDataFormat = [];

        res.data.data.paymentHistory.map((value, index) => {
          let TotalInvoice = (value.taxAmount + value.PMFeeAmount).toFixed(2),
            createdAt = moment(value.createdAt).format("DD-MM-YYYY"),
            callMadeAt = moment(value.callMadeAt).format("DD-MM-YYYY");
          totalPMFee = totalPMFee + Number(value.PMFeeAmount);
          totalTax = totalTax + Number(value.taxAmount);
          totalInvoices = totalInvoices + Number(TotalInvoice);
          monthlySummaryDataFormat.push({
            appointmentId: value.appointmentId,
            createdAt: createdAt,
            PMFeeAmount: value.PMFeeAmount,
            taxAmount: value.taxAmount,
            totalInvoice: TotalInvoice
          });
        });

        if (formValue.csv) {
          monthlySummaryDataFormat.push({
            appointmentId: "-",
            createdAt: "-",
            PMFeeAmount: "$" + totalPMFee.toFixed(2),
            taxAmount: "$" + totalTax.toFixed(2),
            totalInvoice: "$" + totalInvoices.toFixed(2)
          });
          this.setState({
            monthlySummaryCSV: monthlySummaryDataFormat
          });
          document.querySelector("#downloadCSV").click(); // pure js to get the click event + ref is not working with CSVLink element
        }
        if (formValue.pdf) {
          let months = [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
          ];
          let element = this.generateHTMLCode(
            res.data.data.paymentHistory.length,
            months[+formValue.month - 1],
            formValue.year,
            this.state.doctorName,
            this.state.abn,
            this.state.unitNumber,
            this.state.streetNumber + " " + this.state.streetName,
            this.state.suburb,
            this.state.state,
            this.state.postCode,
            this.state.doctorEmail,
            rows,
            totalPMFee,
            totalTax,
            totalInvoices,
            this.state.supportEmail,
            this.state.supportPhone
          );
          // let element = this.generateHTMLCode(res.data.data.paymentHistory.length, months[(+formValue.month) - 1], formValue.year, this.state.doctorName, this.state.abn, this.state.unitNumber, this.state.streetNumber + " " + this.state.streetName, this.state.suburb, this.state.state, this.state.postCode, this.state.doctorEmail, rows, 12000, 1200, 250, this.state.supportEmail, this.state.supportPhone);
          let docH = 305;
          let docW = 600;
          html2pdf(element, {
            margin: 1,
            filename: "MonthlySummary.pdf",
            image: { type: "jpeg", quality: 1 },
            html2canvas: { letterRendering: false, docH, docW, scale: 2 },
            jsPDF: { unit: "mm", format: [docH, docW], orientation: "l" }
          });
        }
        this.closeSummaryModal();
        this.setState({
          apiLoading: false
        });
      },
      failureCallback: err => {
        console.log("Something went wrong. Please try again ", err);
      },
      showPopUp: false
    };
    this.setState({
      apiCall: apiCallParam
    });
  };
  closeSummaryModal = () => {
    this.setState({ openMonthlySummaryModel: false });
  };

  openMonthlySummaryModel = () => {
    this.setState({ openMonthlySummaryModel: true });
  };

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  componentAPICall = data => {
    this.setState({ apiCall: data });
  };

  applyDateFilter = () => {
    this.setState({
      dateFilterApply: {
        startDate: this.state.startDate,
        endDate: this.state.endDate
      },
      filterActive: false
    });
  };

  cancleFilterByDate = () => {
    let dataObj = {
      filterActive: true,
      startDate: new Date(
        moment()
          .subtract(7, "days")
          .format("MM/DD/YYYY")
      ).toISOString(),
      endDate: new Date().toISOString()
    };
    this.setState({
      filterActive: dataObj.filterActive,
      dateFilterApply: {
        startDate: dataObj.startDate,
        endDate: dataObj.endDate
      },
      startDate: dataObj.startDate,
      endDate: dataObj.endDate,
      filterByDateCall: !this.state.filterByDateCall
    });
  };

  generateHTMLCode = (
    arrLength,
    month,
    year,
    doctorName,
    abn,
    streetNumber,
    streetName,
    suburb,
    state,
    postCode,
    doctorEmail,
    tableRows,
    PMFee,
    GST,
    totalInvoice,
    supportEmail,
    supportPhone
  ) => {
    let paymentSlip = "";
    paymentSlip += "";
    paymentSlip += "<!DOCTYPE html>";
    paymentSlip += '<html lang="en">';
    paymentSlip += "<head>";
    paymentSlip += "        <title>Invoice</title>";
    paymentSlip += '            <meta charset="utf-8">';
    paymentSlip +=
      '            <meta name="viewport" content="width=device-width, initial-scale=1">';
    paymentSlip +=
      '            <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css">';
    paymentSlip +=
      '            <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css">';
    paymentSlip +=
      '            <script src="https://ajax.googleapis.com/ajax/libs/jquery/3.2.0/jquery.min.js"></script>';
    paymentSlip +=
      '            <script src="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/js/bootstrap.min.js"></script>';
    paymentSlip += "            <style> body{padding:0px; margin:0px}";
    paymentSlip += "                @font-face {";
    paymentSlip += "        ";
    paymentSlip += "                    font-family: 'AvenirNextBold';";
    paymentSlip += "                    src: url('" + AvenirNextBoldEOT + "');";
    paymentSlip +=
      "                    src: url('" +
      AvenirNextBoldEOT +
      "') format('embedded-opentype'),";
    paymentSlip +=
      "                    url('" + AvenirNextBoldWOFF + "') format('woff'),";
    paymentSlip +=
      "                    url('" +
      AvenirNextBoldTTF +
      "') format('truetype');";
    paymentSlip += "                }";
    paymentSlip += "                @font-face {";
    paymentSlip += "                    font-family: 'AvenirNextRegular';";
    paymentSlip +=
      "                    src: url('" + AvenirNextRegularEOT + "');";
    paymentSlip +=
      "                    src: url('" +
      AvenirNextRegularEOT +
      "') format('embedded-opentype'),";
    paymentSlip +=
      "                    url('" +
      AvenirNextRegularWOFF +
      "') format('woff'),";
    paymentSlip +=
      "                    url('" +
      AvenirNextRegularTTF +
      "') format('truetype');";
    paymentSlip += "                }";
    paymentSlip += "                @font-face {";
    paymentSlip += "                    font-family: 'AvenirNextThin';";
    paymentSlip += "                    src: url('" + AvenirNextThinEOT + "');";
    paymentSlip +=
      "                    src: url('" +
      AvenirNextThinEOT +
      "') format('embedded-opentype'),";
    paymentSlip +=
      "                    url('" + AvenirNextThinWOFF + "') format('woff'),";
    paymentSlip +=
      "                    url('" +
      AvenirNextThinTTF +
      "') format('truetype');";
    paymentSlip += "                }";
    paymentSlip += "                @font-face {";
    paymentSlip += "                    font-family: 'AvenirNextMedium';";
    paymentSlip +=
      "                    src: url('" + AvenirNextMediumEOT + "');";
    paymentSlip +=
      "                    src: url('" +
      AvenirNextMediumEOT +
      "?#iefix') format('embedded-opentype'),";
    paymentSlip +=
      "                    url('" + AvenirNextMediumWOFF + "') format('woff'),";
    paymentSlip +=
      "                    url('" +
      AvenirNextMediumTTF +
      "') format('truetype');";
    paymentSlip += "                    font-weight: 500;";
    paymentSlip += "                    font-style: normal;";
    paymentSlip += "                }";
    paymentSlip += "                .class1 {";
    paymentSlip += "                    max-width: 100%;";
    paymentSlip += "                    width: 100%;";
    paymentSlip += "                    margin: 0 auto;";
    paymentSlip += "                    margin-top: 1%;";
    paymentSlip += "                    padding: 15px 30px;";
    paymentSlip += "                }";

    paymentSlip +=
      ".custom-tbl, .custom-tbl thead tr td, .custom-tbl tbody tr td, .custom-tbl tbody tr { border: 0}";

    paymentSlip += "            </style>";
    paymentSlip += "        </head>";
    paymentSlip += '        <body style="background-color: #f5f8f9;">';
    paymentSlip += '        <div class="container class1">';
    paymentSlip += '            <div class="row" >';
    paymentSlip +=
      '                <div class="col-sm-2 col-md-2 " style="text-align:left;padding:0px;">';
    paymentSlip +=
      '<img src="' +
      FullLogo +
      '" style="width:250px;height:auto;padding-bottom: 3px"  alt="logo"/>';

    paymentSlip += "                </div>";
    paymentSlip +=
      '                <div class="col-sm-2 col-md-2 " style="text-align:right;padding:0px;">';
    paymentSlip +=
      '                    <div style="font-family:AvenirNextMedium; font-size:20px; color: black;font-weight: bold">';

    paymentSlip += "Tax Invoice";

    paymentSlip += "                    </div>";
    paymentSlip +=
      '                    <div style="font-family:AvenirNextMedium; font-size:16px; color: black;padding-bottom: 20px">';

    paymentSlip += month + " " + year;

    paymentSlip += "                    </div>";
    paymentSlip += "                </div>";
    paymentSlip += "            </div>";
    paymentSlip += '            <div class="row">';
    paymentSlip += '                <div class="col-sm-2 col-md-2 "';
    paymentSlip +=
      '                     style="text-align:left;font-family:AvenirNextMedium; font-size:16px; font-weight: bold; top:16px; color: black;padding:0px;padding-top: 7px;">';
    paymentSlip += "                    Instant Consult";
    paymentSlip += "                </div>";
    paymentSlip += '                <div class="col-sm-2 col-md-2 "';
    paymentSlip +=
      '                     style="text-align:right;font-family:AvenirNextMedium; font-size:16px; color: black;padding:0px;padding-top: 16px;">';

    paymentSlip += "Dr. " + doctorName;

    paymentSlip += "                </div>";
    paymentSlip += "            </div>";
    paymentSlip += '            <div class="row">';
    paymentSlip += '                <div class="col-sm-2 col-md-2 "';
    paymentSlip +=
      '                     style="text-align:left;font-family: AvenirNextRegular;top:16px; font-size:16px;color: black;padding-bottom:0px;padding:0px">';
    paymentSlip += "                    ACN: 617 811 337";
    paymentSlip += "                </div>";
    paymentSlip += '                <div class="col-sm-2 col-md-2 "';
    paymentSlip +=
      '                     style="text-align:right;font-family: AvenirNextRegular; font-size:16px;color: black;padding-bottom:3px;padding:0px">';

    paymentSlip +=
      "ABN: " +
      abn.substring(0, 2) +
      " " +
      abn.substring(2, 5) +
      " " +
      abn.substring(5, 8) +
      " " +
      abn.substring(8, 11);

    paymentSlip += "                </div>";
    paymentSlip += "            </div>";
    paymentSlip += '            <div class="row">';
    paymentSlip += '                <div class="col-sm-2 col-md-2 "';
    paymentSlip +=
      '                     style="text-align:left;font-family: AvenirNextRegular; font-size:16px;color: black;top:15px;padding-top:5px; padding-left:0px">';
    paymentSlip +=
      '<img src="' +
      PhoneLogo +
      '" alt="web-log" style="width: 15px; height:15px; margin-right: 3px"" />&nbsp;&nbsp;&nbsp;' +
      supportPhone;

    paymentSlip += "                </div>";
    paymentSlip += '                <div class="col-sm-2 col-md-2 "';
    paymentSlip +=
      '                     style="text-align:right;font-family:AvenirNextRegular; font-size:16px; color: black;padding:0px;text-transform: capitalize;">';

    paymentSlip +=
      streetNumber +
      " " +
      streetName +
      " <br/>" +
      suburb +
      " " +
      state +
      " " +
      postCode;

    paymentSlip += "                </div>";
    paymentSlip += "            </div>";
    paymentSlip += '            <div class="row">';
    paymentSlip += '                <div class="col-sm-2 col-md-2 "';
    paymentSlip +=
      '                     style="position:relative;text-align:left;font-family: AvenirNextRegular; font-size:16px;color: black;padding:0px">';
    paymentSlip +=
      '<img src="' +
      EmailLogo +
      '" alt="web-log" style="width: 15px; height:15px; margin-right: 3px"" /> &nbsp;&nbsp;&nbsp;<span style="position: absolute; top:0; left: 33px;">';

    paymentSlip += supportEmail;
    paymentSlip += "                </span></div>";
    paymentSlip += '                <div class="col-sm-2 col-md-2 "';
    paymentSlip +=
      '                     style="text-align:right;font-family:AvenirNextMedium;font-size:16px;color: rgb(245,171,53) !important;padding:0px;padding-top:3px;">';

    paymentSlip += doctorEmail;

    paymentSlip += "                </div>";
    paymentSlip += "            </div>";
    paymentSlip += '            <div class="row">';
    paymentSlip +=
      '                <div class="col-sm-12 col-lg-12 col-xs-12 col-md-12 "';
    paymentSlip +=
      '                     style="text-align:left;font-family: AvenirNextRegular; font-size:16px;color: black;padding:0px">';
    paymentSlip +=
      '<img src="' +
      WebLogo +
      '" alt="web-log" style="width: 15px; height:15px; margin-right: 3px"" /> &nbsp;&nbsp;&nbsp;instantconsult.com.au';

    paymentSlip += "                </div>";
    paymentSlip += "            </div>";

    paymentSlip += '            <div class="row" style="padding-top:1%">';
    paymentSlip += '                <div class="col-sm-2 col-md-2 "';
    paymentSlip +=
      '                     style="text-align:left;font-family:AvenirNextMedium;font-size: 16px;color: black;padding:0px">';
    paymentSlip +=
      "                    Practice Management Fee - " + month + " " + year;
    paymentSlip += "                </div>";
    paymentSlip += '                <div class="col-sm-2 col-md-2 "';
    paymentSlip +=
      '                     style="text-align:right;font-family:AvenirNextMedium;font-size: 16px;color: black;padding:0px">';

    // paymentSlip += '$' + (PMFee).toFixed(2);
    paymentSlip += new Intl.NumberFormat("au-AU", {
      style: "currency",
      currency: "AUD"
    })
      .format(PMFee)
      .slice(1);

    paymentSlip += "                </div>";
    paymentSlip += "            </div>";
    paymentSlip += '            <div class="row" style="margin-top: 8px;">';
    paymentSlip += '                <div class="col-sm-2 col-md-2 "';
    paymentSlip +=
      '                     style="text-align:left;font-family:AvenirNextMedium;font-size: 16px;color: black;padding:0px">';
    paymentSlip += "                    GST on Practice Management Fee";
    paymentSlip += "                </div>";
    paymentSlip += '                <div class="col-sm-2 col-md-2 "';
    paymentSlip +=
      '                     style="text-align:right;font-family:AvenirNextMedium;font-size: 16px;color: black;padding:0px">';

    // paymentSlip += '$' + (GST).toFixed(2);
    paymentSlip += new Intl.NumberFormat("au-AU", {
      style: "currency",
      currency: "AUD"
    })
      .format(GST)
      .slice(1);

    paymentSlip += "                </div>";
    paymentSlip += "            </div>";
    paymentSlip += '            <div class="row" style="padding-top:10px;">';
    paymentSlip += '                <div class="col-sm-2 col-md-2"';
    paymentSlip +=
      '                     style="background-color: rgb(245,245,245) !important;text-align:left;font-family:AvenirNextMedium;font-size: 18px;font-weight: bold;color: black;padding:0px">';
    paymentSlip += "                    Total Earnings";
    paymentSlip += "                </div>";
    paymentSlip += '                <div class="col-sm-2 col-md-2 rightRow"';
    paymentSlip +=
      '                     style="background-color: rgb(245,245,245) !important;text-align:right;font-family:AvenirNextMedium;font-size: 18px;font-weight: bold;color: black;padding:0px">';

    // paymentSlip += '$' + (totalInvoice).toFixed(2);
    paymentSlip += new Intl.NumberFormat("au-AU", {
      style: "currency",
      currency: "AUD"
    })
      .format(totalInvoice)
      .slice(1);

    paymentSlip += "                </div>";
    paymentSlip += "            </div>";
    paymentSlip += "        </div>";
    paymentSlip += "        </body>";
    paymentSlip += "        </html>";

    return paymentSlip;
  };

  render() {
    return (
      <div className="row rounded p-3 tax-invoice-page">
        {/* Top Filters */}
        <div className="col-sm-5 p-3">
          <Label title="Tax Invoices" className="big" />
        </div>
        <div className="col-sm-12"></div>
        <div className="col-sm-3 pt-2">
          <ICDateInput
            id="startdate"
            name="startdate"
            className="cal-primary-bg"
            label=""
            defaultDate={this.state.startDate}
            handleChange={date =>
              this.setState({ startDate: date, filterActive: true })
            }
            filterOn={this.state.startDate}
          />
        </div>
        <div className="col-sm-3 pt-2">
          <ICDateInput
            id="enddate"
            name="enddate"
            className="cal-primary-bg"
            label=""
            defaultDate={this.state.endDate}
            handleChange={date =>
              this.setState({ endDate: date, filterActive: true })
            }
            filterOn={this.state.endDate}
          />
        </div>
        <div className="col-sm-6 pt-0">
          {/* <ICButton title="Apply Filter" type="button" clickEvent={this.applyDateFilter} /> */}
          <ICIconBtn
            title=""
            className={this.state.filterActive ? "font-15 only-icon" : "d-none"}
            type="button"
            clickEvent={this.applyDateFilter}
            icon="fas fa-arrow-right"
          />

          <ICIconBtn
            title=""
            className={
              !this.state.filterActive ? "font-15 only-icon danger" : "d-none"
            }
            type="button"
            clickEvent={this.cancleFilterByDate}
            icon="fas fa-times"
          />

          <ICButton
            title="Monthly Summary"
            type="button"
            className="ml-4"
            clickEvent={this.openMonthlySummaryModel}
          />
        </div>
        <div className="col-sm-12 border-bottom mt-3"></div>

        <div className="col-sm-12 mt-4">
          <TaxInvoiceList
            startDate={this.state.startDate}
            endDate={this.state.endDate}
            makeAPICall={this.componentAPICall}
            dateFilterApply={this.state.dateFilterApply}
          />
        </div>

        <MonthlySummaryModel
          openModal={this.state.openMonthlySummaryModel}
          okayText="Okay"
          cancelText="Cancel"
          title="Export Monthly Summary Report"
          useOneButton={false}
          onFormSubmit={this.downloadMonthlySummary}
          cancelEvent={this.closeSummaryModal}
        />

        {this.state.monthlySummaryCSV && this.state.monthlySummaryCSV.length ? (
          <CSVLink
            id="downloadCSV"
            ref={this.csvInput}
            filename={"Monthly_Summary.csv"}
            className="d-none"
            data={this.state.monthlySummaryCSV}
            headers={this.state.headers}
          >
            {" "}
            Download me{" "}
          </CSVLink>
        ) : (
          ""
        )}

        {/* API Call */}
        <MakeAPICall apiParam={this.state.apiCall} />

        {/* Loader */}
        <Loader loading={this.state.apiLoading} />
      </div>
    );
  }
}

// export default TaxInvoicesPage;

const mapStateToProps = props => ({
  auth: props.auth.user
});

const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(TaxInvoicesPage);
